import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import apiService from '../../services/apiService';
import { PageLoader } from '../../components/PageLoader'; // Import the loader component

const SettingsView = ({ user }) => {
    const { refetchUser } = useAuth();
    const [name, setName] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    // Use useEffect to safely set the initial state once the user prop is available.
    // This prevents issues with the component trying to render with incomplete data.
    useEffect(() => {
        if (user?.name) {
            setName(user.name);
        }
    }, [user]);

    // **CRITICAL FIX**: Add a guard clause at the top of the component.
    // This prevents any rendering from happening until both `user` and `user.account`
    // are fully loaded, which is the most common cause of this type of crash.
    if (!user || !user.account) {
        return <PageLoader text="Loading settings..." />;
    }

    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        try {
            if (user?._id) {
                await apiService.updateUserProfile(user._id, { name });
                await refetchUser();
                alert("Profile updated successfully!");
            } else {
                throw new Error("User ID is not available.");
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <main className="p-8">
            <h1 className="text-4xl font-bold text-white mb-8">Settings</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="bg-[#0A142C] p-6 rounded-lg border border-slate-700">
                    <h2 className="text-2xl font-semibold text-white mb-4">My Profile</h2>
                    <form onSubmit={handleProfileUpdate} className="space-y-4">
                        <div>
                            <label htmlFor="displayName" className="block mb-2 text-sm font-medium text-slate-300">Display Name</label>
                            <input type="text" id="displayName" value={name} onChange={e => setName(e.target.value)} required className="bg-slate-700 border border-slate-600 text-white text-sm rounded-lg block w-full p-2.5" />
                        </div>
                         <div>
                            <label className="block mb-2 text-sm font-medium text-slate-300">Email</label>
                            <p className="text-slate-400">{user.email}</p>
                        </div>
                        <button type="submit" disabled={isSaving} className="w-full bg-[#16e2c3] text-black font-bold py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-slate-600">
                            {isSaving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </form>
                </div>
                <div className="bg-[#0A142C] p-6 rounded-lg border border-slate-700">
                     <h2 className="text-2xl font-semibold text-white mb-4">Account Information</h2>
                     <div className="space-y-3 text-sm">
                        <div className="flex justify-between"><span className="text-slate-400">Account Name:</span> <span className="text-white">{user.account.name}</span></div>
                        <div className="flex justify-between"><span className="text-slate-400">Account ID:</span> <span className="text-white font-mono text-xs">{user.account._id}</span></div>
                        <div className="flex justify-between"><span className="text-slate-400">Account Owner:</span> <span className="text-white">{user.account.owner?.name || 'N/A'}</span></div>
                        {/* Add checks for dates to prevent "Invalid Date" errors */}
                        <div className="flex justify-between"><span className="text-slate-400">Created:</span> <span className="text-white">{user.account.createdAt ? new Date(user.account.createdAt).toLocaleDateString() : 'N/A'}</span></div>
                        <div className="flex justify-between"><span className="text-slate-400">Last Activity:</span> <span className="text-white">{user.lastActivity ? new Date(user.lastActivity).toLocaleString() : 'N/A'}</span></div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default SettingsView;
